import {AppModule} from 'appmodule/login/App'
import {initLogin} from 'appmodule/login/component/initLogin'

document.addEventListener("DOMContentLoaded", () => {
	console.debug("DOM fully loaded!")
	initLogin(AppModule)
});